import React from 'react'
import Fragment from '../common/fragment'


function FragmentBF(props) {
  return (
    <Fragment pos="ff" {...props}>
      <p>
“Ptonia Melissa, Señora de las Abejas, ataviada con ofrendas zumbadoras,
aguijoneadoras y melosas” (Haraway, 91)
      </p>
    </Fragment>
  )
}


export default FragmentBF
